import jishikaijiang from '../../Jishikaijiang/columns/xyrb';
export default {
  list: Vue => {
    return jishikaijiang().list(Vue);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/History/columns/xyrb.js